module.exports = __webpack_public_path__ + "static/media/36.7f5b6eb0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/36.svg
// module id = 406
// module chunks = 14